/// <amd-module name="Wit/UI/WorkItemViews" />
export { IWorkItemSmallViewProps } from "./Components/WorkItemSmallView/WorkItemSmallView.Props";
export * from "./Components/WorkItemSmallView/WorkItemSmallView";

export { IWorkItemViewProviderProps } from "./WorkItemViewProvider.Props";
export * from "./WorkItemViewProvider";
